import { Component, OnInit } from '@angular/core';
import { ApiIntegration } from '../../_services/api.integration';
import { Router, ActivatedRoute } from '@angular/router';
import { User } from '../../_models/user';
import { Globals } from '../../_models/globals';

@Component({
  selector: 'app-view-account-owner',
  templateUrl: './view-account-owner.component.html',
  styleUrls: ['./view-account-owner.component.scss'],
})
export class ViewAccountOwnerComponent implements OnInit {

  viewCustomer: any = {};
  viewCustomerOrderCount: any = {};
  addresses: any;

  constructor(private router: Router, public route: ActivatedRoute, private g: Globals, public user: User, private api: ApiIntegration) {
    this.g.loaderDisplay = "display";
    this.api.getAccountOwner(this.route.snapshot.params['id']).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewCustomer = data;
      this.addresses = this.viewCustomer.adddressList;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
    this.api.getOrderCountByCustomer(this.route.snapshot.params['id'], this.user.organizationId).subscribe((data: any) => {
      this.g.loaderDisplay = "";
      this.viewCustomerOrderCount = data;
    }, err => {
      console.log(err);
      this.g.loaderDisplay = "";
    });
  }

  editCustomers() {
    this.router.navigate(['/admin/editAccountOwner/' + this.viewCustomer.id]);
  }

  ngOnInit() { }

}
